import { ViewChild } from '@angular/core';
import { WorkrequestCmpComponent } from '../workrequest-cmp/workrequest-cmp.component';
import { LoginService } from '../../../shared/services/login.service';
import { CmpService } from '../cmp.service';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { PlumberDetailsComponent } from '../../../shared/components/plumber-details/plumber-details.component';
import { PlumberDetails } from '../../../shared/data-objects/plumber-details';
import { UploadfilesViewmodel } from '../../../shared/viewmodels/uploadfiles-viewmodel';
import { Steps } from 'primeng/primeng';
import { IppaymentService } from '../../../shared/services/ippayment.service';
import { ApplicationFormBase } from '../../../shared/data-objects/application-form-base';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import { Cmp } from '../cmp';
import { ApplicationBase } from '../../../shared/data-objects/application-base';
import { FireCmpComponent } from '../fire-cmp/fire-cmp.component';
import { FireCmpViewmodel } from '../fire-cmp-viewmodel';
import { WorkrequestCmpViewmodel } from '../workrequest-cmp-viewmodel';
import { WorkrequestCmpDetails } from '../workrequest-cmp-details';
import { UploadFile3Component } from "../../../shared/components/upload-file3/upload-file3.component";
import { FeeService } from '../../../shared/services/fee.service';

const referenceNumberRE = /^[a-zA-Z0-9\-\/\.\:]+$/;

Steps.prototype.itemClick = MenuUtils.itemClick;

export abstract class CmpComponent extends ApplicationFormBase<Cmp> {
  isRequesting: boolean;
  refNumControl: FormControl;
  refNumControlLength = 11;
  protected paymentActiveIndex: number;
  fire = false;
  cwwPricingZone: boolean = false;

  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestCmpComponent;
  @ViewChild('PlumberDetailsComponent') plumberDetailsComponent: PlumberDetailsComponent;
  @ViewChild('FireCmpComponent') fireCmpComponent: FireCmpComponent;
  @ViewChild("uploadComponent") uploadComponent: UploadFile3Component;

  constructor(protected loginService: LoginService,
    protected cmpService: CmpService, protected ipPaymentService: IppaymentService,
    protected router: Router, protected feeService: FeeService) {
    super(cmpService, loginService, ipPaymentService, router);
    this.refNumControl = new FormControl('', [Validators.maxLength(this.refNumControlLength), Validators.pattern(referenceNumberRE)]);
    this.sitePlansConfirmed = true;
  }

  loadFees(): void {
    this.feeService.retrieveFees('ComplexPlumbing', this.loginService.getToken(), ok => {
        if (ok) {
          this.workRequestViewModel.applicationFeeAmount = this.feeService.getCMPApplicationFeeAmount(this.locationDetails.pricingZone, this.fireCmpViewModel.fireServiceYes);
          // this.onFeeCodesReceived.emit();
          console.log(`application fees: $${this.workRequestViewModel.applicationFeeAmount}`);
        } else {
          console.log('no fees found');
        }
      },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  formatFees(feeAmount: number) {
    if (feeAmount) {
      return feeAmount.toFixed(2);
    } else {
      return null;
    }
  }

  updatePaymentTab(showPaymentInfo: boolean, idx: number, description: string): void {
    const me = this;
    this.removeMenuItem('Payment', me);
    if (showPaymentInfo) {
      this.addMenuItem('Payment', me, idx, description);
    }
  }

  onFeeCodesReceived(): void {
  }

  get controlLabel(): string {
    return 'Upload document';
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  get commitDisabled(): boolean {
    return (
      (!this.cmpService.agreedToTsAndCs1 ||
        !this.cmpService.agreedToTsAndCs2) ||
      !this.cmpService.agreedToTsAndCs ||
      this.applicant.invalid ||
      this.location.invalid ||
      this.workrequestComponent.invalid ||
      this.plumberDetailsComponent.invalid ||
      this.refNumControl.invalid
    );
  }

  get plumberDetails(): PlumberDetails {
    return (this.cmpService.applicationData).plumberDetails;
  }

  get workRequestViewModel(): WorkrequestCmpViewmodel {
    return this.cmpService.workRequestViewModel;
  }

  get fireCmpViewModel(): FireCmpViewmodel {
    return this.cmpService.fireCmpViewModel;
  }

  get uploadfilesViewmodel(): UploadfilesViewmodel {
    return this.cmpService.uploadfilesViewmodel;
  }

  get hydraulicPlansConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).hydraulicPlansConfirmed;
  }

  set hydraulicPlansConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).hydraulicPlansConfirmed = v;
  }

  get architecturalPlansConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).architecturalPlansConfirmed;
  }

  set architecturalPlansConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).architecturalPlansConfirmed = v;
  }

  get basementPlansConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).basementPlansConfirmed;
  }

  set basementPlansConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).basementPlansConfirmed = v;
  }

  get firePlansConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).firePlansConfirmed;
  }

  set firePlansConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).firePlansConfirmed = v;
  }

  get sitePlansConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).sitePlansConfirmed;
  }

  set sitePlansConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).sitePlansConfirmed = v;
  }

  get groundAnchorsConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).groundAnchorsConfirmed;
  }

  set groundAnchorsConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).groundAnchorsConfirmed = v;
  }

  get pumpCurvesConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).pumpCurvesConfirmed;
  }

  set pumpCurvesConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).pumpCurvesConfirmed = v;
  }

  get planOfSubConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).planOfSubConfirmed;
  }

  set planOfSubConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).planOfSubConfirmed = v;
  }

  get otherConfirmed(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).otherConfirmed;
  }

  set otherConfirmed(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).otherConfirmed = v;
  }

  set agreedToTsAndCs1(v: boolean) {
    this.cmpService.agreedToTsAndCs1 = v;
  }

  set agreedToTsAndCs2(v: boolean) {
    this.cmpService.agreedToTsAndCs2 = v;
  }

  abstract canGoNext(executeYes: any, executeNo: any): void;

  protected canGoNextFormLevel(executeYes: any, executeNo: any): void {
    if (this.refNumControl.hasError('maxlength')) {
      this.cmpService.submitErrorMessage += 'Customer order/reference number cannot exceed ' + this.refNumControlLength + ' characters';
      executeNo();
      return;
    }
    if (this.refNumControl.hasError('pattern')) {
      this.cmpService.submitErrorMessage += 'Please enter valid Customer order/reference number; ' +
        'Alphanumeric characters along with - / : . are allowed e.g. 123-abc, 123/abc, 123:ABC, 123.ABC';
      executeNo();
      return;
    }
    this.validTermsAndConditions(executeNo, executeYes);
  }

  goNext(): void {
    // if ((!this.isGuestUserLoggedIn && this.activeIndex === (this.paymentActiveIndex - 1)) || (this.isGuestUserLoggedIn && this.activeIndex === this.paymentActiveIndex)) {
    if ((this.loginService.isUserBillLater() && this.activeIndex === (this.paymentActiveIndex - 1)) ||
      (!this.loginService.isUserBillLater() && this.activeIndex === this.paymentActiveIndex)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });

    if (this.activeIndex === 3) {
      // load fees here based on where fire is selected or not
      console.log(this.workRequestViewModel);
      this.loadFees();
    }
  }

  canGoPrevious(): boolean {
    // if (this.isGuestUserLoggedIn && (this.activeIndex === this.paymentActiveIndex || this.activeIndex === 0)) {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === this.paymentActiveIndex || this.activeIndex === 0)) {
      return false;
    }

    // if (!this.isGuestUserLoggedIn && this.activeIndex === 0) {
    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  get cmp(): ApplicationBase {
    return this.cmpService.applicationData;
  }

  submitApplication(callback): void {
    let validData = true;
    this.cmpService.submitErrorMessage = '';

    if (this.location.invalid) {
      this.cmpService.submitErrorMessage += this.location.displayErrorMessage();
      validData = false;
    }

    this.workrequestComponent.errorMessage = null;
    if (!this.workrequestComponent.invalid && this.workrequestComponent.displayErrorMessage().length > 0) {
      this.cmpService.submitErrorMessage += this.workrequestComponent.displayErrorMessage();
      validData = false;
    }

    this.plumberDetailsComponent.errorMessage = null;
    if (this.plumberDetailsComponent.invalid) {
      this.cmpService.submitErrorMessage += this.plumberDetailsComponent.displayErrorMessage();
      validData = false;
    }

    /*   if (!this.uploadFileComponent.isValid) {
          this.cmpService.submitErrorMessage += this.uploadFileComponent.submitErrorMessage;
          validData = false;
        }*/

    if (this.applicant.invalid) {
      this.cmpService.submitErrorMessage += this.applicant.displayErrorMessage();
      validData = false;
    }

    if (!this.cmpService.agreedToTsAndCs ||
      this.isRecycledWaterZone &&
      (!this.cmpService.agreedToTsAndCs1 ||
        !this.cmpService.agreedToTsAndCs2)) {
      this.cmpService.submitErrorMessage += 'Please select terms and conditions.';
      validData = false;
    }

    if (!validData) {
      return;
    }

    this.setApplicantData();
    this.cmpService.applicationData.toUpperCase();
    this.cmpService.applicationData.plumberDetails = this.plumberDetailsComponent.plumberDetails;
    this.cmpService.applicationData.workrequestDetails =
      <WorkrequestCmpDetails>this.workrequestComponent.workRequestViewModel.workrequestDetails;
    this.cmpService.applicationData.locationAddress = this.location.addressDetails.locationAddress;
    this.cmpService.applicationData.workrequestDetails.propertyOnCombinedDrain = this.workrequestComponent.workRequestViewModel.propertyOnCombinedDrain ? this.workrequestComponent.workRequestViewModel.propertyOnCombinedDrain : 'Unknown';
    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.uploadFileComponent.clearFiles();
    //this.workrequestComponent.clearDevelopmentType();
    //this.fireCmpComponent.markValidationControlsAsUntouched();
    //this.workrequestComponent.markValidationControlsAsUntouched();
    //this.plumberDetailsComponent.markValidationControlsAsUntouched();
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayFire(): boolean {
    return this.fire && this.activeIndex === 2;
  }

  get shouldDisplayPlumberDetails(): boolean {
    return this.fire ? this.activeIndex === 3 : this.activeIndex === 2;
  }

  get shouldDisplayUploadFiles(): boolean {
    return this.fire ? this.activeIndex === 4 : this.activeIndex === 3;
  }

  get shouldDisplayApplicant(): boolean {
    return this.fire ? this.activeIndex === 5 : this.activeIndex === 4;
  }

  get shouldShowReviewAndSubmit(): boolean {
    return this.fire ? this.activeIndex === 6 : this.activeIndex === 5;
  }

  get shouldDisplayPaymentForm(): boolean {
    // return this.isGuestUserLoggedIn && this.activeIndex === this.paymentActiveIndex;
    return !this.loginService.isUserBillLater() && this.activeIndex === this.paymentActiveIndex;
  }

  get shouldDisplayNextButton(): boolean {
    // return (!this.isGuestUserLoggedIn && !this.shouldShowReviewAndSubmit)
    //   || (this.isGuestUserLoggedIn && !(this.shouldShowReviewAndSubmit || this.shouldDisplayPaymentForm));
    return (this.loginService.isUserBillLater() && !this.shouldShowReviewAndSubmit)
      || (!this.loginService.isUserBillLater() && !(this.shouldShowReviewAndSubmit || this.shouldDisplayPaymentForm));
  }

  get shouldDisplayRecycledWaterTCs(): boolean {
    return this.isRecycledWaterZone;
  }

  get shouldShowPaymentInfo(): boolean {
    return !this.isUserBillLater && this.cwwPricingZone;
  }

  private doSubmit(callback): void {
    this.executeSubmit('cmp', callback, this.workRequestViewModel.applicationFeeAmount, null, true, null, this.uploadComponent);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/cmp/cmp.component.ts